import React, { useContext } from "react";
import { Box } from "@mui/material";
import SidebarContext from "../../../context/SidebarContext";
import Header from "./Header";
import AddStoreStepper from "./AddStoreStepper";

function AddStore() {
  const { open } = useContext(SidebarContext);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "96vh",
          margin: "20px",
          marginRight: "0px",
          width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "12px",
        }}
      >
        <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
          <Header pageTitle={`Create Store`} currentRoute={`Create Store`} />
        </Box>
        <Box sx={{ marginTop: 0 }}>
          <AddStoreStepper />
        </Box>
      </Box>
    </>
  );
}

export default AddStore;
